import { render, staticRenderFns } from "./ReturnTransferAccess.vue?vue&type=template&id=d8dd2ba0&scoped=true&"
import script from "./ReturnTransferAccess.vue?vue&type=script&lang=js&"
export * from "./ReturnTransferAccess.vue?vue&type=script&lang=js&"
import style0 from "./ReturnTransferAccess.vue?vue&type=style&index=0&id=d8dd2ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8dd2ba0",
  null
  
)

export default component.exports